import { useEffect } from "react";

/**
 * Has the browser ask before a refresh or tab close while `active`. In-app navigation
 * is a router blocker's job; this covers leaving the app altogether.
 */
export function useWarnBeforeUnload(active: boolean) {
  useEffect(() => {
    if (!active) {
      return;
    }

    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Older browsers only prompt when returnValue is set.
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", warn);

    return () => window.removeEventListener("beforeunload", warn);
  }, [active]);
}
